module.exports = __webpack_public_path__ + "img/hand_sideleft_Blank.a00565ab.svg";